import React, { useState } from "react";
import { baseUrl } from '../library/comoda';

export default function StampaFile() {
  const [file, setFile] = useState<File | null>(null);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [risposta, setRisposta] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    setFile(selectedFile);
    setShowPassword(!!selectedFile?.name.toLowerCase().endsWith(".pdf"));
    setPassword("");
  };

  const stampa = async () => {
    if (!file) {
      setRisposta("Seleziona un file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    if (showPassword && password) {
      formData.append("password", password);
    }

    setLoading(true);
    setRisposta("Invio in corso...");

    try {
      const res = await fetch(`${baseUrl}stampa.php`, {
        method: "POST",
        body: formData,
      });
      const text = await res.text();
      setRisposta(text);
    } catch {
      setRisposta("Errore durante l'invio.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="box background altezzafissa">
      <h1>Invia file in stampa</h1>
      <input type="file" accept=".pdf,.txt,.jpg,.png,.doc,.docx" onChange={handleFile} />
      {showPassword && (
        <input
          type="password"
          placeholder="Password PDF (se richiesta)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input margini"
        />
      )}
      <button className="btn command" onClick={stampa} disabled={loading}>
        Stampa
      </button>

      <div className="conferma margini">
        {loading ? <p>Attendere...</p> : <pre className="scrollable-pre">{risposta || "Nessun risultato."}</pre>}
      </div>
    </div>
  );
}
